import { css } from '@emotion/react'
import { isEmpty } from 'lodash-es'
import type { HTMLAttributes } from 'react'
import EmptyPlaceholder from '../EmptyPlaceholder'
import PageLoading from '../PageLoading'
import Comment, { type CommentData } from './Comment'

export interface CommentListProps extends HTMLAttributes<HTMLDivElement> {
	/**
	 * comment id list
	 */
	data: CommentData[]
	isLoading?: boolean
}

export default function CommentList({ data, isLoading = false, ...props }: CommentListProps) {
	return (
		<div {...props}>
			{isLoading ? (
				<PageLoading
					css={css`
						margin-top: 100px;
					`}
					noFixed
				/>
			) : isEmpty(data) ? (
				<EmptyPlaceholder
					title="暂无评论"
					css={css`
						margin-top: 32px;
					`}
				/>
			) : (
				data.map((item) => (
					<Comment
						data={item}
						key={item.id}
						css={css`
							padding: 20px 15px;
							box-shadow: 0 0.5px 0 0 var(--tint-separator);
						`}
					/>
				))
			)}
		</div>
	)
}
